
import * as React from "react"
import { cn } from "@/lib/utils"
import { useSidebar } from "./sidebar-provider"

const SidebarMenu = ({ className, children, ...props }: React.HTMLAttributes<HTMLUListElement>) => {
  return (
    <ul className={cn("space-y-1", className)} {...props}>
      {children}
    </ul>
  )
}
SidebarMenu.displayName = "SidebarMenu"

const SidebarMenuItem = ({ className, children, ...props }: React.HTMLAttributes<HTMLLIElement>) => {
  return (
    <li className={cn("px-3", className)} {...props}>
      {children}
    </li>
  )
}
SidebarMenuItem.displayName = "SidebarMenuItem"

const SidebarMenuButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { asChild?: boolean }
>(({ className, asChild = false, children, ...props }, ref) => {
  const { isCollapsed } = useSidebar();
  const Comp = asChild ? React.Fragment : "button";
  
  // If the sidebar is fully collapsed, don't render menu buttons
  if (isCollapsed) {
    return null;
  }
  
  return (
    <Comp
      ref={!asChild ? ref : undefined}
      className={cn(
        "flex items-center w-full h-10 rounded-md hover:bg-accent hover:text-accent-foreground transition-all duration-200",
        "px-3",
        className
      )}
      {...(!asChild ? props : {})}
    >
      {React.Children.map(children as React.ReactElement, (child) => {
        if (child.type === 'a' || (typeof child.type === 'function' && child.type.name === 'Link')) {
          return React.cloneElement(child, {
            ...child.props,
            className: cn(
              "flex items-center w-full h-10 rounded-md hover:bg-accent hover:text-accent-foreground transition-all duration-200",
              "px-3 gap-3",
              child.props.className
            ),
            children: child.props.children
          });
        }
        return child;
      })}
    </Comp>
  );
});
SidebarMenuButton.displayName = "SidebarMenuButton"

export { SidebarMenu, SidebarMenuItem, SidebarMenuButton }
